export const colors = {
  // Primary Theme Colors
  primary: "#FFFFFF",
  secondary: "#4A2E1B",
  accent: "#D4A373",

  // Backgrounds & Surfaces
  background: "#FAF7F2",
  surface: "#FFFFFF",
  surfaceSecondary: "#F5EBE0",
  surfaceHover: "#FAF4EE",

  // Typography
  textPrimary: "#231815",
  textSecondary: "#6B5E57",
  textMuted: "#9E9188",
  textLight: "#FFFFFF",
  textDark: "#231815",
  textInverse: "#FFFFFF",

  // Borders & Dividers
  border: "#E8DFD8",
  divider: "#F5EBE0",

  // Cards
  card: "#FFFFFF",
  cardHover: "#FFFFFF",

  // Overlays & Modals
  overlay: "rgba(0, 0, 0, 0.5)",
  modalBackground: "#FFFFFF",
  modalHeader: "#FFFFFF",
  modalFooter: "#F5EBE0",

  // Tables
  tableHeader: "#4A2E1B",
  tableHeaderText: "#FFFFFF",
  tableRow: "#FFFFFF",
  tableHover: "#FAF4EE",

  // Inputs & Forms
  inputBackground: "#FFFFFF",
  inputBorder: "#D8CFC4",
  inputPlaceholder: "#9E9188",

  // Buttons
  buttonPrimary: "#4A2E1B",
  buttonHover: "#6F4228",
  buttonText: "#FFFFFF",
  buttonPrimaryHover: "#6F4228",
  buttonPrimaryText: "#FFFFFF",
  buttonSecondary: "#FFFFFF",
  buttonSecondaryText: "#4A2E1B",
  buttonSecondaryBorder: "#4A2E1B",

  // Badges & Statuses
  badgeSuccess: "#4A2E1B",
  badgeSuccessText: "#FFFFFF",
  badgeWarning: "#F59E0B",
  badgeWarningText: "#111827",
  badgeDanger: "#DC2626",
  badgeDangerText: "#FFFFFF",
  badgeInfo: "#2563EB",
  badgeInfoText: "#FFFFFF",

  // Feedback Statuses
  success: "#4A2E1B",
  warning: "#F59E0B",
  danger: "#DC2626",
  info: "#2563EB",

  // Footer & Navbar
  footer: "#361F14",
  footerText: "#FFFFFF",
  footerLink: "#D8CFC4",
  footerLinkHover: "#D4A373",

  navbar: "#4A2E1B",
  navbarText: "#FFFFFF",
  navbarHover: "#D4A373",

  // Icons & Shadows
  icon: "#4A2E1B",
  iconHover: "#6F4228",
  shadow: "0 4px 12px rgba(74, 46, 27, 0.08)",
};

export const applyTheme = (themeColors = colors) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;

  const mapping = {
    primary: themeColors.primary,
    secondary: themeColors.secondary,
    accent: themeColors.accent,
    background: themeColors.background,
    surface: themeColors.surface,
    "surface-secondary": themeColors.surfaceSecondary || "#F5EBE0",
    "surface-hover": themeColors.surfaceHover || "#FAF4EE",
    "text-primary": themeColors.textPrimary,
    "text-secondary": themeColors.textSecondary,
    "text-muted": themeColors.textMuted || "#9E9188",
    "text-light": themeColors.textLight || "#FFFFFF",
    "text-dark": themeColors.textDark || "#231815",
    "text-inverse": themeColors.textInverse || "#FFFFFF",
    border: themeColors.border,
    divider: themeColors.divider || "#F5EBE0",
    card: themeColors.card || "#FFFFFF",
    "card-hover": themeColors.cardHover || "#FFFFFF",
    overlay: themeColors.overlay || "rgba(0,0,0,0.5)",
    "modal-background": themeColors.modalBackground || "#FFFFFF",
    "modal-header": themeColors.modalHeader || "#FFFFFF",
    "modal-footer": themeColors.modalFooter || "#F5EBE0",
    "table-header": themeColors.tableHeader || "#4A2E1B",
    "table-header-text": themeColors.tableHeaderText || "#FFFFFF",
    "table-row": themeColors.tableRow || "#FFFFFF",
    "table-hover": themeColors.tableHover || "#FAF4EE",
    "input-background": themeColors.inputBackground || "#FFFFFF",
    "input-border": themeColors.inputBorder || "#D8CFC4",
    "input-placeholder": themeColors.inputPlaceholder || "#9E9188",
    "button-primary": themeColors.buttonPrimary || "#4A2E1B",
    "button-primary-hover": themeColors.buttonHover || themeColors.buttonPrimaryHover || "#6F4228",
    "button-primary-text": themeColors.buttonText || themeColors.buttonPrimaryText || "#FFFFFF",
    "button-secondary": themeColors.buttonSecondary || "#FFFFFF",
    "button-secondary-text": themeColors.buttonSecondaryText || "#4A2E1B",
    "button-secondary-border": themeColors.buttonSecondaryBorder || "#4A2E1B",
    "badge-success": themeColors.badgeSuccess || "#4A2E1B",
    "badge-success-text": themeColors.badgeSuccessText || "#FFFFFF",
    "badge-warning": themeColors.badgeWarning || "#F59E0B",
    "badge-warning-text": themeColors.badgeWarningText || "#111827",
    "badge-danger": themeColors.badgeDanger || "#DC2626",
    "badge-danger-text": themeColors.badgeDangerText || "#FFFFFF",
    "badge-info": themeColors.badgeInfo || "#2563EB",
    "badge-info-text": themeColors.badgeInfoText || "#FFFFFF",
    success: themeColors.success,
    warning: themeColors.warning,
    danger: themeColors.danger,
    info: themeColors.info,
    footer: themeColors.footer,
    "footer-text": themeColors.footerText || "#FFFFFF",
    "footer-link": themeColors.footerLink || "#D8CFC4",
    "footer-link-hover": themeColors.footerLinkHover || "#D4A373",
    navbar: themeColors.navbar || "#4A2E1B",
    "navbar-text": themeColors.navbarText || "#FFFFFF",
    "navbar-hover": themeColors.navbarHover || "#D4A373",
    icon: themeColors.icon || "#4A2E1B",
    "icon-hover": themeColors.iconHover || "#6F4228",
    shadow: themeColors.shadow || "0 4px 12px rgba(74, 46, 27, 0.08)",
  };

  Object.entries(mapping).forEach(([key, val]) => {
    root.style.setProperty(`--${key}`, val);
  });
};

export default colors;
